import { Row, Col, Stack, Card, Button } from "react-bootstrap";
import { AppIcon } from "@/components/Icon";

export function SupportSection() {
  return (
    <Card className="border-0 rounded-lg p-4">
      <Stack gap={3}>
        <Row>
          <Col xs="auto">
            <div
              style={{
                width: 56,
                height: 56,
                background: "#F3F4F6",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AppIcon name="Headphones" size={28} className="text-muted" />
            </div>
          </Col>
        </Row>

        <Stack gap={1}>
          <div className="fw-semibold fs-5 text-black">
            Looking for help?
          </div>
          <div className="text-muted">
            Contact us by creating a ticket now.
          </div>
        </Stack>
      </Stack>
    </Card>
  );
}